import { render, staticRenderFns } from "./AprovisionarServicoComponent.vue?vue&type=template&id=62e0deb2&scoped=true"
import script from "./AprovisionarServicoComponent.vue?vue&type=script&lang=js"
export * from "./AprovisionarServicoComponent.vue?vue&type=script&lang=js"
import style0 from "./AprovisionarServicoComponent.vue?vue&type=style&index=0&id=62e0deb2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62e0deb2",
  null
  
)

export default component.exports